import React from "react";
import { WorkflowLevelPermissionType } from "@certa/queries/types/permissions.types";
import { Chokidar } from "../Chokidar";
import { PermissionTypes } from "@certa/types";
import { Chowkidaar } from "@certa/common/utils/permissions/Chowkidar";

type WizardStatusChokidarProps = {
  processId?: number;
  children: React.ReactChild;
};

export const ChokidarWFStatusPermissionBasedOnToggle = ({
  children,
  processId
}: WizardStatusChokidarProps) => {
  if (processId) {
    return (
      <Chokidar
        checkFor={WorkflowLevelPermissionType.CAN_VIEW_WORKFLOW_PROFILE}
        processId={processId}
      >
        {children}
      </Chokidar>
    );
  }
  return (
    <Chowkidaar check={PermissionTypes.CAN_VIEW_WORKFLOW_PROFILE}>
      {children}
    </Chowkidaar>
  );
};
